import { useGetAgencyInformationForUser } from '@urbanx/agx.agencies.client';
import { Outlet } from 'react-router-dom';

const AuthenticatedLayout = () => {
  useGetAgencyInformationForUser();

  return <Outlet />;
};

export default AuthenticatedLayout;
